// extracted by mini-css-extract-plugin
module.exports = {"c-prose":"Prose_c-prose__kdupx","c-prose--bullet":"Prose_c-prose--bullet__Tp7Pp"};